const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';

export const OPTIONS = { loop: true };
export const designSlides = [
  {
    name: 'normal',
    image: pluginUrl + 'normal.png',
    cssClass: '',
  },
  {
    name: 'amp',
    image: pluginUrl + 'amp.png',
    cssClass: 'ampBackground',
  },
  {
    name: 'heart',
    image: pluginUrl + 'heart.png',
    cssClass: 'heartBackground',
  },
  {
    name: 'nameDate',
    image: pluginUrl + 'nameDate.png',
  },
  {
    name: 'nameLocation',
    image: pluginUrl + 'nameLocation.png',
    cssClass: 'nameLocation',
  },
  {
    name: 'nameLocationMap',
    image: pluginUrl + 'nameLocationMap.png',
    cssClass: 'nameLocationMap',
  },
  {
    name: 'wedding',
    image: pluginUrl + 'wedding.png',
    cssClass: 'weddingBackground',
  },
];

export const cropSlides = [
  {
    name: 'normal',
    image: pluginUrl + 'normalCrop.png',
    cssClass: 'normal',
  },
  {
    name: 'thinner',
    image: pluginUrl + 'thinnerCrop.png',
    cssClass: 'thinner-mask',
  },
  {
    name: 'circle',
    image: pluginUrl + 'circleCrop.png',
    cssClass: 'circle-mask',
  },
  {
    name: 'heart',
    image: pluginUrl + 'heartCrop.png',
    cssClass: 'heart-mask',
  },
  {
    name: 'flatter',
    image: pluginUrl + 'flatterCrop.png',
    cssClass: 'flatter-mask',
  },
];
